import React, {useEffect, useState} from "react";
import {observer} from 'mobx-react'
import {Link} from "react-router-dom";
import {AppBar} from "@mui/material";
import DynamicAvatar from "./DynamicAvatar";
import {routes} from "../../App";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ConditionalComponent from "./ConditionalComponent";
import Button from "@mui/material/Button";
import Utility from "../../Utility";
import Settings from '../../settings.json';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import frontlineLogo from '../../assets/img/frontlineio-logo.png'
import frontlineMobileLogo from '../../assets/img/frontlineio-logo-mobile.svg'
import {NotificationsPanel} from "./NotificationsPanel";
import {when} from "mobx";
import {isIOS, isMacOs, isTablet} from "react-device-detect";
import GetAppIcon from '@mui/icons-material/GetApp';
import SvgShapes from "../../assets/live-svg/shapes.svg";
import {useStores} from "../../Hooks";
import LogoutIcon from '../../assets/img/logout.svg';
import sharedUtils from "../../serverClientShared/sharedUtils";
import {history} from "../../index";
import {useLocation} from 'react-router-dom';
import {WorkspaceFlags} from "../../serverClientShared/sharedEnums";
import SearchInput from "./Search/SearchInput";
import GlobalUtility from "../../Utilities/GlobalUtility";
import RemoteSupportButton from "./RemoteSupportButton";

const TopAppBar = observer(props => {
    const location = useLocation();
    const {generalStore, dataStore, modalStore, procedureStore} = useStores();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [myDetailsAnchor, setMyDetailsAnchor] = useState(null);
    const workspaceName = generalStore.workspaceName;
    const workspace = generalStore.workspace;

    let deviceName = generalStore.translate('pc').toUpperCase();
    if (Utility.isAndroid()) {
        deviceName = generalStore.translate('android');
    } else if (isIOS) {
        deviceName = 'iOS';
    } else if (isMacOs) {
        deviceName = generalStore.translate('mac');
    }

    const isWithBackButton = props.match && props.match.path === routes.EDITOR;

    const hideTopBar = generalStore.hideTopBar;

    async function logOut() {
        const noLogOut = generalStore.checkPreventLeave();
        if (noLogOut) {
            return closeMenu();
        } else generalStore.preventLeaveActive = false;
        dataStore.deleteAll();
        generalStore.isLoaderOpen = true;
        generalStore.onTheWayOut = true;
        try {
            await generalStore.removeDevice();
        } catch (e) {
            console.error(e);
        }
        generalStore.isLoaderOpen = false;
        await generalStore.logOut();
    }

    function login() {
        const noNavAway = generalStore.checkPreventLeave();
        if (noNavAway) {
            return closeMenu();
        } else generalStore.preventLeaveActive = false;
        generalStore.onTheWayOut = true;
        const storeReset = generalStore.onTheWayOut && !generalStore.preventLeaveActive;
        when(() => storeReset).then(async () => {
            dataStore.deleteAll();
            generalStore.redirectToAfterLogin = window.location.pathname;
            if (workspace !== sharedUtils.LOGIN_DOMAIN) {
                generalStore.goToLogin(false);
            } else {
                history.push(routes.LOGIN)
            }
        });
    }

    function signup() {
        const noNavAway = generalStore.checkPreventLeave();
        if (noNavAway) {
            return closeMenu();
        } else generalStore.preventLeaveActive = false;
        generalStore.onTheWayOut = true;
        const storeReset = generalStore.onTheWayOut && !generalStore.preventLeaveActive;
        when(() => storeReset).then(async () => {
            generalStore.redirectToAfterLogin = window.location.pathname;
            const workspaceUpdated = generalStore.workspace;
            if (workspaceUpdated !== sharedUtils.LOGIN_DOMAIN) {
                generalStore.goToLogin(true)
            } else {
                history.push(routes.SIGNUP)
            }
        });
    }

    function closeMenu() {
        setDropdownOpen(false);
        setMyDetailsAnchor(null);
    }

    function openMenu(event) {
        setDropdownOpen(true);
        setMyDetailsAnchor(event.target);
    }

    function openNotificationsPanel() {
        generalStore.openNotificationsPanel();
    }

    function renderAvatar() {
        const userImage = generalStore.userDetails.UserIcon;
        const user = generalStore.userDetails;
        return (
            <DynamicAvatar
                className='user-initials'
                imageSrc={userImage}
                user={user}
            />
        );
    }

    function renderMyDetailsDropdown() {
        if (!generalStore.loggedIn) {
            return null;
        }

        const isDomainAdmin = generalStore.checkWorkspaceAdmin;
        return (
            <div className="user-badge-menu-btn">
                <div onClick={openMenu}>
                    {renderAvatar()}
                </div>
                <Menu
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    open={dropdownOpen}
                    onClose={closeMenu}
                    anchorEl={myDetailsAnchor}
                    className='appbar-menu'
                    disableAutoFocusItem
                    getContentAnchorEl={null}
                >
                    <MenuItem className='dropdown-item inactive'>
                        {renderAvatar()}
                        <span>{generalStore.userDetails.Email}</span>
                    </MenuItem>


                    <MenuItem className='dropdown-item' onClick={() => history.push(routes.ACCOUNT_SETTINGS)}>
                        {generalStore.translate('accountSettings')}
                    </MenuItem>


                    <MenuItem className='dropdown-item' onClick={() => modalStore.isSwitchDomainModalOpen = true}>
                        {generalStore.translate('switchWorkspaces')}
                    </MenuItem>

                    <ConditionalComponent if={!!isDomainAdmin}>
                        <MenuItem
                            className='dropdown-item'
                            onClick={() => history.push(routes.MEMBERS)}
                        >
                            {generalStore.translate('workspaceManagement')}
                        </MenuItem>
                    </ConditionalComponent>
                    <Divider variant='middle'/>

                    <MenuItem className='dropdown-item' onClick={() => logOut()}>
                        <img src={LogoutIcon} alt=''/>{generalStore.translate('logout')}
                    </MenuItem>
                </Menu>
            </div>
        );
    }

    async function openFrontlineArModal() {
        const deepLink = `procedureio://frontline-ar?d=${Settings.frontlineArServer}`;
        window.location.href = deepLink;
        modalStore.modalData = {
            deepLink
        }
        modalStore.isFrontlineArDialogOpen = true;
    }


    function renderButtons() {
        const notificationNum = generalStore.numUnreadNotifications;

        return (
            <div className="appbar-links">
                <ConditionalComponent if={generalStore.loggedIn}>
                    <ConditionalComponent if={!isTablet && !Utility.isMobile()}>
                        <RemoteSupportButton/>
                    </ConditionalComponent>
                    <Button
                        onClick={openFrontlineArModal}
                        className='frontline-ar-button hide-in-mobile hide-in-tablet'
                    >
                        <span
                            style={{textTransform: "initial"}}>{deviceName}&nbsp;</span>{generalStore.translate('app')}
                    </Button>
                    <IconButton
                        onClick={openFrontlineArModal}
                        className='frontline-ar-button show-in-mobile show-in-tablet'
                    >
                        <GetAppIcon/>
                    </IconButton>
                    <Link to={routes.MAIN_DASHBOARD}>
                        <div className='hide-in-mobile hide-in-tablet'>{generalStore.translate('myProjects')}</div>

                        <IconButton className='show-in-mobile show-in-tablet'>
                            <SvgShapes width={25} height={21}/>
                        </IconButton>
                    </Link>
                </ConditionalComponent>
                <ConditionalComponent if={!generalStore.loggedIn}>
                    <div onClick={login}>{generalStore.translate('login')}</div>
                    <div onClick={signup}>{generalStore.translate('signUp')}</div>
                </ConditionalComponent>

                <ConditionalComponent if={generalStore.loggedIn}>
                    <div style={{position: 'relative', padding: '0px'}}>
                        {generalStore.notificationsPanelOpen &&
                            <span onClick={(e) => e.stopPropagation()}
                                  style={{position: 'absolute', inset: 0, zIndex: 1}}></span>}
                        <IconButton
                            style={{color: "#FFFFFF"}}
                            onClick={openNotificationsPanel}
                            aria-label={notificationNum + " unread notifications"}
                            color="inherit"
                        >
                            <Badge
                                badgeContent={notificationNum}
                                max={99}
                                color="error"
                                overlap="circular"
                            >
                                <NotificationsIcon className='bell-icon header-icons-theme'/>
                            </Badge>
                        </IconButton>
                    </div>
                </ConditionalComponent>
            </div>
        )
    }

    const goBack = () => {
        if (location.pathname.includes('/edit/')) {
            generalStore.selectedNodeId = '';
            const procedure = procedureStore.currentProcedure;
            const parts = location.pathname.split('/');
            const projectId = parts[3];
            const nestedRoute = procedure?.NestedFolderRoute;
            const folderPath = nestedRoute?.split('/').slice(1).join('/');
            const suffix = folderPath
                ? `${folderPath}/${procedure.ProcedureIdentifier}`
                : `${parts[4]}/${parts[5]}`;
            const targetPath = `/project/${projectId}/procedures/${suffix}/`;
            history.push(targetPath);
        } else {
            history.goBack();
        }
    }

    useEffect(() => {
        generalStore.getAllNotifications().then();
        // eslint-disable-next-line
    }, []);

    return (
        <ConditionalComponent if={!generalStore.isInFullscreen && !hideTopBar}>
            <AppBar position="fixed" className='app-bar'>
                <div className='appbar-start'>
                    <ConditionalComponent if={!!isWithBackButton}>
                        <ArrowBackIcon className="back-btn" onClick={goBack}/>
                    </ConditionalComponent>
                    <Link to={routes.ROOT} className='logo-container'>
                        <div className="logo">
                            <img src={generalStore.theme?.LogoUrl || frontlineLogo} alt=''
                                 className='desktop-logo hide-in-mobile'/>
                            <ConditionalComponent if={!Utility.isMobile()}>
                                <span
                                    className='workspace-logo'> {workspace !== 'super-admin' ? workspaceName : ''} </span>
                            </ConditionalComponent>
                            <img src={generalStore.theme?.LogoUrl || frontlineMobileLogo} alt=''
                                 className='show-in-mobile'/>
                        </div>
                    </Link>
                </div>

                <div className="appbar-middle">
                    <SearchInput/>
                </div>
                <div className="appbar-end">
                    {renderButtons()}
                    {renderMyDetailsDropdown()}
                </div>
            </AppBar>
            <NotificationsPanel/>
        </ConditionalComponent>

    );
})

export default TopAppBar;
